module.exports = __webpack_public_path__ + "img/hero_screenshot.41aca346.png";